import React from 'react';
import clsx from 'clsx';
import './XSSection.css';
import { XSBox, XSBoxInput } from '../box/XSBox';
import { XSText } from '../text/XSText';

export type XSSectionInput = XSBoxInput & (Shared | RowInput);

type Shared = {
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    block?: boolean;
    fullWidth?: boolean;
    wide?: boolean;
};

type RowInput = Shared & {
    type: 'row';
};

export function XSSection(input: XSSectionInput) {
    const { title, subtitle, block, fullWidth, wide, children, style } = input;
    const isToolbar = Boolean(title || subtitle);

    let Element = input.as || 'section';
    let content = children;

    const className: string[] = [];

    if (block) {
        Element = 'div';
        className.push('block');
    }

    if (wide || fullWidth) {
        className.push('wide');
    }

    if ('type' in input) {
        className.push(`XSSection-type-${input.type || ''}`);
    }

    if (isToolbar) {
        // Element = 'div';

        content = (
            <>
                <div className={'XSSection-content-left'}>
                    {title && (
                        <XSText type={'title'} className={'title'}>
                            {title}
                        </XSText>
                    )}
                    {subtitle && <div className={'subtitle'}>{subtitle}</div>}
                </div>

                <div className={'XSSection-content-right'}>{children}</div>
            </>
        );
    }

    let component = (
        <XSBox
            {...input}
            as={Element}
            className={clsx(`XSSection`, input.className, className, { isToolbar })}
            style={style}>
            {content}
        </XSBox>
    );

    return component;
}
